export default __webpack_public_path__ + "static/media/Path 5278.35bd707f.svg";